export const pricing = [
  {
    id: "starter",
    theme: "plus",
    icon: "pin",
    name: "Plus",
    description: "Get found locally.",
    originalPrice: "₹4,999",
    price: "₹1,499",
    note: "Limited-time offer · one-time payment",
    popular: false,
    features: [
      { label: "Google Business Profile setup", available: true },
      { label: "Add business to Google Maps", available: true },
      { label: "Map and path editing", available: true },
      { label: "Business details optimization", available: true },
      { label: "Showcase products website", available: false },
      { label: "Custom small business website", available: false },
    ],
    cta: "Choose Plus",
  },
  {
    id: "intermediate",
    theme: "pro",
    icon: "code",
    name: "Pro",
    description: "Showcase products online.",
    originalPrice: "₹9,999",
    price: "₹4,499",
    note: "Limited-time setup offer · plus annual server & maintenance",
    popular: true,
    features: [
      { label: "Google Business Profile setup", available: true },
      { label: "Add business to Google Maps", available: true },
      { label: "Map and path editing", available: true },
      { label: "Business details optimization", available: true },
      { label: "Showcase products website", available: true },
      { label: "Custom small business website", available: false },
    ],
    cta: "Choose Pro",
  },
  {
    id: "custom-website",
    theme: "business",
    icon: "layers",
    name: "Business",
    description: "A website built around your needs.",
    originalPrice: "₹47,999",
    price: "₹28,499",
    note: "Setup offer, subject to negotiation · plus annual server & maintenance",
    popular: false,
    features: [
      { label: "Google Business Profile setup", available: true },
      { label: "Add business to Google Maps", available: true },
      { label: "Map and path editing", available: true },
      { label: "Business details optimization", available: true },
      { label: "Custom small business website", available: true },
    ],
    cta: "Choose Business",
  },
];
